module.exports = {"3000":"Over 3000 lbs","0-100":"0-100 lbs","100-250":"100 - 250 lbs","250-500":"250 - 500 lbs","500-1000":"500 - 1000 lbs","1000-1500":"1000 - 1500 lbs","1500-2000":"1500 - 2000 lbs","2000-3000":"2000 - 3000 lbs"}


//////////////////
// WEBPACK FOOTER
// ./src/config/heatRange.json
// module id = 5411
// module chunks = 1